import { useEffect, useState } from 'react';
import { useGrippContext } from '../grippContext';
import { useStorageKeys } from '../storage/useStorageKeys';

/**
 * Hook that reads deferred deep link data from storage and parses query parameters
 * Returns an object with parsed query params (e.g., { invitationId: 'abc123' })
 */
export const useDeferredDeepLink = () => {
  const [params, setParams] = useState<Record<string, string | null>>({});
  const { storageHandler } = useGrippContext();
  const storageKeys = useStorageKeys();

  useEffect(() => {
    const loadDeepLink = async () => {
      const value = await storageHandler.getItem(storageKeys.deepLinkData);

      if (!value) {
        setParams({});
        return;
      }

      try {
        const searchParams = new URLSearchParams(value);
        const parsed: Record<string, string | null> = {};

        searchParams.forEach((value, key) => {
          parsed[key] = value;
        });

        setParams(parsed);
      } catch (error) {
        setParams({});
      }
    };

    loadDeepLink();
  }, [storageHandler, storageKeys.deepLinkData]);

  return params;
};
